

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { loading: false, data: [], error: "", message: "" }


export const supportDataAction = createAsyncThunk(
    'support-data',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/support-knowladges/${data.page}/${data.limit}/${data.is_deleted}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const supportDataSlice = createSlice({
    name: 'support-data',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(supportDataAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(supportDataAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.message = action?.payload?.message
            })
            builder.addCase(supportDataAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.message = action?.payload?.message
            })
        },

})



export const supportDataReducer = supportDataSlice.reducer    






// router.get("/support-knowladges/:page/:limit/:is_deleted", new SupportKnowladge().supportKnowladgeList)
// router.get("/support-knowladge/:id", new SupportKnowladge().supportKnowladgeDetail)
// router.post("/support-knowladge", new SupportKnowladge().createSupportKnowladge)
// router.put("/support-knowladge", new SupportKnowladge().updateSupportKnowladge)
// router.delete("/support-knowladge", new SupportKnowladge().deleteAndResoteSupportKnowladge)